import { render, staticRenderFns } from "./OrdenCompraEmision.vue?vue&type=template&id=5ef18f01&scoped=true&"
import script from "./OrdenCompraEmision.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraEmision.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraEmision.vue?vue&type=style&index=0&id=5ef18f01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef18f01",
  null
  
)

export default component.exports